// extracted by mini-css-extract-plugin
module.exports = {"table_wrapper":"MetricsTable_table_wrapper__HqtWv","table_content":"MetricsTable_table_content__LFf6a","modal_root":"MetricsTable_modal_root__X3NrF"};